import gql from 'graphql-tag';

export default gql`
query GetMyApp(
        $uuid: String!
        ) {
    getMyApp(
        uuid: $uuid
    ) {
        uuid
        user    # the publisher
        lang    # Publisher language (deduced from preferences/browser)
        origin  # uuid, for translations only

        image  # uuid of the cover image

        # State
        completed   # publisher's intent to publish
        approval    # premoderation passed, e.g.:
                    # 0-49: auto
                    #  0: sanity check (not audio)
                    #  5: sanity check (audio)
                    #  10: profanity/hate speech in text
                    #  15: profanity/hate speech in audio
                    # 50: pending support check
                    # 75: pending publisher check (e.g. translations)
                    # 99: pending editor check (e.g. selected areas)
                    # a message to 
        published   # final verdict to publish
        promoted

        # Tags
        tag1
        tag2
        tag3
        tag4
        tag5

        # Guide info
        guideName
        guideDesc
        guideImage

        # App info
        name
        desc

        # Price / Financial
        type # 0: free, 1: rent only, 2: buy only, 3: rent or buy
        currency
        rentPrice
        rentDays
        buyPrice
        promoted
        allowTranslations # publisher's intent to approve translations
        translatorShare # income share to give to translator
        translatorLimit # income limit to give to translator (100% share is assumed until then)

        endpoints {
            uuid
            user
            name
            desc
            images
            tag1
            tag2
            tag3
            tag4
            tag5
        }

        endpointIds

        linkWeb
        linkYoutube
        linkFacebook
        linkInstagram
        linkTwitter

        importedFrom
        importedId
    }
}
`;
